<template>
  <div>
    <header>
      <v-container>
        <v-row no-gutters>
          <h1 class="font-weight-light headline">
            {{ $t("title.clients") }}
          </h1>
          <v-spacer></v-spacer>
          <v-lazy v-if="isClientsLoaded" transition="fade-transition">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="searchLabel"
              single-line
              dense
              hide-details
              style="max-width: 200px"
              class="mr-5 pr-5"
            ></v-text-field>
          </v-lazy>
          <v-lazy transition="fade-transition">
            <v-btn
              color="success"
              dark
              small
              @click.stop="
                dialog.clientForm = true;
                isClientEdited = false;
              "
              >{{ $t("general.add") }}</v-btn
            >
          </v-lazy>
          <v-dialog scrollable v-model="dialog.dialogImport" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="#17a2b8"
                style="color: #ffffff"
                @click="dialog.dialogImport = true"
                small
                class="ml-3"
              >
                {{ $t("clients.import") }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ $t("clients.import") }}</span>
              </v-card-title>

              <v-card-text>
                <input
                  type="file"
                  class="form-control"
                  :class="{
                    ' is-invalid': error.error,
                    ' is-valid': success.success
                  }"
                  id="input-file-import"
                  name="Importar contactos"
                  ref="import_file"
                  @change="onFileChange"
                />
                <br />
                <div v-if="error.error" class="alert alert-danger">
                  <ul>
                    <li v-for="error in error.error">
                      {{ error }}
                    </li>
                  </ul>
                </div>
                <div v-if="success.success" class="alert alert-success">
                  {{ success.success }}
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="proceedAction">
                  {{ $t("clients.import") }}
                </v-btn>
                <v-btn @click="closeImport">
                  {{ $t("cancel") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </header>
    <section class="py-7">
      <v-container>
        <v-sheet class="px-3 pt-3 pb-3" v-if="!clients.length">
          <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
        </v-sheet>
        <v-card v-else>
          <v-data-table :headers="headers" :items="clients" :search="search">
            <template v-slot:item.action="{ item }">
              <div style="display: flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-tr-class-on-hover="'blue'"
                      size="20px"
                      color="blue"
                      class="mr-2"
                      @click="editUser(item)"
                      v-on="on"
                      >mdi-pencil-outline</v-icon
                    >
                  </template>
                  <span>{{ $t("general.edit") }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      size="22px"
                      color="red"
                      v-tr-class-on-hover="'red'"
                      class="mr-2"
                      @click="confirmDelete(item)"
                      v-on="on"
                      >mdi-delete-outline</v-icon
                    >
                  </template>
                  <span>{{ $t("general.delete") }}</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.is_active="{ item }">
              <v-switch
                class="mt-0 pt-0 justify-content-center"
                hide-details
                color="green"
                v-model="item.is_active"
                @change="changeStatus(item)"
              ></v-switch>
            </template>
            <template v-slot:item.company="{ item }">
              <span v-if="item.company == null">-</span>
              <span v-else>{{ item.company.name }}</span>
            </template>
            <template v-slot:item.internal_id="{ item }">
              <span v-if="item.internal_id == null">-</span>
              <span v-else>{{ item.internal_id }}</span>
            </template>
            <template v-slot:item.division="{ item }">
              <span v-if="item.division == null">-</span>
              <span v-else>{{ item.division.name }}</span>
            </template>
            <template v-slot:item.section="{ item }">
              <span v-if="item.section == null">-</span>
              <span v-else>{{ item.section.name }}</span>
            </template>
            <template v-slot:item.start_date="{ item }">
              {{getFormatedDate(item.start_date)}}
            </template>
            <template v-slot:item.last_test_date="{ item }">
              <span v-if="item.training">{{getFormatedDate(item.training.updated_at, true)}}</span>
            </template>
            <template v-slot:item.next_test_date="{ item }">
              <span v-if="item.training && item.training.state == 2">{{getNextDate(item.training.updated_at)}}</span>
            </template>
            <template v-slot:item.last_test_name="{ item }">
              <span>{{ getLastTestName(item) }}</span>
            </template>
          </v-data-table>
        </v-card>
        <ClientForm
          :client="selectedClient"
          :visible="dialog.clientForm"
          :isEdited="isClientEdited"
          :variables="variables"
          @addClient="addClient"
          @updateClient="updateClient"
          @close="dialog.clientForm = false"
          @snackMessage="snackMessage"
        />

        <ConfirmationDialog
          :name="selectedClient.name"
          :text="'clients.delete_confirmation'"
          v-if="dialog.confirmation"
          @confirm="deleteClient"
          @cancel="cancelDelete"
        />

        <SnackMessage ref="SnackMessage" />
      </v-container>
    </section>
  </div>
</template>

<script>
import ClientForm from "../components/ClientForm";
import ConfirmationDialog from "../components/ConfirmationDialog";
import SnackMessage from "../components/SnackMessage";
import moment from "moment";
export default {
  data() {
    return {
      settings: {
        test_frequency: {
            key: "test_frequency",
            value: "",
            loading: true
        },
      },
      clients: [],
      isClientsLoaded: false,
      search: "",
      dialog: {
        confirmation: false,
        clientForm: false,
        dialogImport: false
      },
      client: {
        name: null,
        surname: null,
        company_id: null,
        managers_name: null,
        start_date: null,
        internal_id: null,
        section_id: null,
        delivery_note_2: null,
        delivery_note: null,
        is_active: null,
      },
      selectedClient: {
        name: null,
        surname: null,
        company_id: null,
        managers_name: null,
        start_date: null,
        internal_id: null,
        section_id: null,
        delivery_note_2: null,
        delivery_note: null,
        is_active: null,
      },
      defaultClient: {
        name: null,
        surname: null,
        company_id: null,
        managers_name: null,
        start_date: null,
        internal_id: null,
        section_id: null,
        delivery_note_2: null,
        delivery_note: null,
        is_active: null,
      },
      isClientEdited: false,
      variables: {
        app_domain: "",
        is_division: "",
        is_errors_available: "",
        app_name: "",
      },
      error: {},
      success: {},
      import_file: "",
    };
  },

  components: {
    ClientForm,
    ConfirmationDialog,
    SnackMessage,
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("general.actions"),
          value: "action",
          sortable: false,
        },
        {
          text: this.$t("clients.internal_id_table"),
          align: "left",
          sortable: false,
          value: "internal_id",
        },
        {
          text: this.$t("clients.name"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("clients.surname"),
          align: "left",
          sortable: false,
          value: "surname",
        },
        {
          text: this.$t("clients.section"),
          align: "left",
          sortable: false,
          value: "section",
        },
        {
          text: this.$t("clients.start_date"),
          align: "left",
          sortable: false,
          value: "start_date",
        },
        {
          text: this.$t("clients.managers_name_table"),
          align: "left",
          sortable: false,
          value: "managers_name",
        },
        {
          text: this.$t("clients.last_test_name"),
          align: "left",
          sortable: false,
          value: "last_test_name",
        },
        {
          text: this.$t("clients.last_test_date_table"),
          align: "left",
          sortable: false,
          value: "last_test_date",
        },
        {
          text: this.$t("clients.next_test_date_table"),
          align: "left",
          sortable: false,
          value: "next_test_date",
        },
      ];
    },
    searchLabel() {
      return this.$t("general.search");
    },
  },

  created() {
    this.getSettings();
    this.getClients();
    this.getVariables();
  },

  methods: {
    getLastTestName(item) {
      let name = ''
      if(item.training && item.training.modul) {
        name+= item.training.modul.name
      }
      if(item.training && item.training.scenario) {
        name+= ', ' + item.training.scenario.name
      }
      return name
    },
    onFileChange(e) {
      this.import_file = e.target.files[0];
    },
    proceedAction() {
      let formData = new FormData();
      formData.append("import_file", this.import_file);
      axios
        .post("/importClients", formData, {
          headers: { "content-type": "multipart/form-data" }
        })
        .then(response => {
          if (response.status === 200) {
            this.error = {};
            this.success = response.data;
            this.dialog.dialogImport = false;
            this.$refs.import_file.value = null;
            this.getClients()
          }
        })
        .catch(error => {
          // code here when an upload is not valid
          this.uploading = false;
          this.success = {};
          this.$refs.import_file.value = null;
          this.error = error.response.data;
          console.log("check error: ", this.error);
        });
    },
    closeImport() {
      setTimeout(() => {
        this.$refs.import_file.value = null;
      }, 300);
      this.error = {};
      this.success = {};
      this.dialog.dialogImport = false;
    },
    getNextDate(last_date) {
      const days = Number(this.settings.test_frequency.value * 30)
      let date = new Date(Date.parse(last_date));
      date.setDate(date.getDate() + parseInt(days));
      
      let dateTimeFormat = new Intl.DateTimeFormat("en", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
      let [
        { value: month },
        ,
        { value: day },
        ,
        { value: year }
      ] = dateTimeFormat.formatToParts(date);
      return `${day}.${month}.${year}`;
    },
    getFormatedDate(date, witTime = false) {
      return date != null &&
          date != ""
            ? moment(date).format("DD.MM.YYYY" + (witTime ? (' HH:mm') : ''))
            : date;
    },
    getVariables() {
      axios
        .get("/api/getVariables", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.variables = response.data;
        });
    },
    snackMessage(msg, type) {
      this.$refs.SnackMessage.showMessage(msg, type);
    },

    async getClients() {
      await axios
        .get("/api/clientList", {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.clients = response.data;
          this.isClientsLoaded = true;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    addClient(client) {
      this.clients.push(client);
      this.getClients();
    },
    editUser(item) {
      this.selectedClient = Object.assign({}, item);
      this.dialog.clientForm = true;
      this.isClientEdited = true;
    },
    updateClient(client) {
      let index = this.clients.findIndex((item) => item.id == client.id);
      this.clients.splice(index, 1, client);
      this.getClients();
    },
    confirmDelete(item) {
      this.selectedClient = item;
      this.dialog.confirmation = true;
    },
    cancelDelete() {
      this.dialog.confirmation = false;
    },
    async deleteClient() {
      this.dialog.confirmation = false;
      let index = this.clients.indexOf(this.selectedClient);

      await axios
        .delete(`/api/deleteClient/${this.selectedClient.id}`, {
          headers: {
            Authorization:
              "Bearer " + this.$store.state.tokenData.user.access_token,
          },
        })
        .then((response) => {
          this.selectedClient = this.defaultClient;
          this.clients.splice(index, 1);

          this.$refs.SnackMessage.showMessage(
            "clients.deleted_successfully",
            "success"
          );
        })
        .catch((error) => {
          console.log(error);
          this.$refs.SnackMessage.showMessage("general.error", "error");
        });
    },
    async changeStatus(item) {
      try {
        const request = await axios.put(
          "/api/updateStatusClient/" + item.id,
          item,
          {
            headers: {
              Authorization:
                "Bearer " + this.$store.state.tokenData.user.access_token,
            },
          }
        );
        this.getClients();
        this.snackMessage("general.item_saved", "success");
      } catch (error) {
        console.error(error);
      }
    },
    async getSettings() {
      await axios
        .get("/api/settings", {
            headers: {
                Authorization:
                    "Bearer " +
                    this.$store.state.tokenData.user.access_token
            }
        })
        .then(response => {
            let settings = Object.keys(this.settings).map(
                i => this.settings[i]
            );
            response.data.forEach(function(item, index) {
              let setting = settings.find(s => s.key === item.key);
              if (setting) {
                  setting.value = item.value;
                  setting.loading = false;
              }
            });
        })
        .catch(error => {
            console.log(error);
            this.$refs.SnackMessage.showMessage(
                "general.error",
                "error"
            );
        });
      },
  },
};
</script>
